/* ═══════════════════════════════════════════════════════
   Monmouth Cards — TCG & Pokemon Sealed Collection Filters
   (Set / Expansion search + chips)
   assets/monmouth-tcg-sealed-filters.js

   Sealed Type / Year / Language / Availability are plain checkboxes,
   rendered server-side in monmouth-filter-sidebar.liquid — no JS needed
   for those beyond the shared multi-select engine already wired up by
   monmouth-collection.js.

   Set / Expansion is the one search + autocomplete + multi-select-chips
   widget in this taxonomy (same interaction pattern as Team (Sports) /
   Set (Wax) / Set & Character (Pokemon)), so "Scarlet & Violet or
   Chilling Reign" works the same way "PSA or SGC" does elsewhere.

   Unlike the Sports/Wax/Pokemon widgets, this one has NO fetched JSON
   asset — window.MC_TCG_SEALED_SET_VALUES is embedded inline by
   monmouth-filter-sidebar.liquid, sourced live from collection.all_tags
   for the CURRENT collection only (via monmouth-tags-by-prefix). That
   also means it's naturally already scoped to one game's sets, unlike
   the JSON-file approach which would need per-collection filtering.

   Re-entrant: window.MC.initTcgSealedFilters() is called both on first
   page load and after every AJAX section-replace (monmouth-collection.js),
   since that swap destroys and recreates this markup from scratch. The
   inline <script> that sets window.MC_TCG_SEALED_SET_VALUES only runs on
   the initial full page load (see the comment in monmouth-filter-sidebar
   .liquid), but that's fine — the value list is the same for every filter
   combination on a given collection page, so the stale-after-swap concern
   that applies to per-navigation state (current tags) doesn't apply here.
   ═══════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var SET_PREFIX = 'set-';

  function getSetValues() {
    return Array.isArray(window.MC_TCG_SEALED_SET_VALUES) ? window.MC_TCG_SEALED_SET_VALUES : [];
  }

  function handleize(str) {
    if (window.MC && typeof window.MC.handleize === 'function') return window.MC.handleize(str);
    return String(str || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function escapeHtml(s) {
    var div = document.createElement('div');
    div.textContent = s;
    return div.innerHTML;
  }

  function installGlobalDismissListener() {
    if (window._mcTcgSealedDismissInstalled) return;
    window._mcTcgSealedDismissInstalled = true;
    document.addEventListener('click', function (e) {
      var box = document.getElementById('mc-tcg-set-suggestions');
      var input = document.getElementById('mc-tcg-set-search');
      if (box && input && !box.contains(e.target) && e.target !== input) {
        box.hidden = true;
      }
    });
  }

  function wireAutocomplete(opts) {
    var input = document.getElementById(opts.inputId);
    var box = document.getElementById(opts.boxId);
    if (!input || !box) return;

    var currentMatches = [];
    var activeIndex = -1;

    function renderSuggestions(matches, query) {
      currentMatches = matches;
      activeIndex = -1;
      if (!matches.length) {
        box.innerHTML = query
          ? '<div class="mc-sidebar__suggestion mc-sidebar__suggestion--empty">' + escapeHtml(opts.emptyLabel) + '</div>'
          : '';
        box.hidden = !query;
        return;
      }
      box.innerHTML = matches.map(function (name, i) {
        return '<button type="button" class="mc-sidebar__suggestion" data-index="' + i + '">' + escapeHtml(name) + '</button>';
      }).join('');
      box.hidden = false;
    }

    function highlight(items) {
      items.forEach(function (el, i) {
        el.classList.toggle('mc-sidebar__suggestion--active', i === activeIndex);
      });
    }

    function choose(name) {
      if (!name) return;
      box.hidden = true;
      opts.onChoose(name, input);
    }

    input.addEventListener('input', function () {
      var query = input.value.trim().toLowerCase();
      if (!query) { renderSuggestions([], ''); return; }
      var pool = opts.getPool();
      var matches = pool
        .filter(function (name) { return name.toLowerCase().indexOf(query) !== -1; })
        .slice(0, 8);
      renderSuggestions(matches, query);
    });

    box.addEventListener('click', function (e) {
      var btn = e.target.closest('.mc-sidebar__suggestion');
      if (!btn || btn.classList.contains('mc-sidebar__suggestion--empty')) return;
      choose(currentMatches[parseInt(btn.dataset.index, 10)]);
    });

    input.addEventListener('keydown', function (e) {
      if (box.hidden || !currentMatches.length) return;
      var items = box.querySelectorAll('.mc-sidebar__suggestion:not(.mc-sidebar__suggestion--empty)');
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        activeIndex = Math.min(activeIndex + 1, items.length - 1);
        highlight(items);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        activeIndex = Math.max(activeIndex - 1, 0);
        highlight(items);
      } else if (e.key === 'Enter') {
        if (activeIndex >= 0) {
          e.preventDefault();
          choose(currentMatches[activeIndex]);
        }
      } else if (e.key === 'Escape') {
        box.hidden = true;
      }
    });
  }

  function renderChips() {
    var container = document.getElementById('mc-tcg-set-chips');
    if (!container) return;
    var state = window.MC && window.MC.multiSelect ? window.MC.multiSelect.getState() : null;
    var selected = (state && state.multi && state.multi.set) || [];

    container.innerHTML = selected.map(function (tag) {
      var label = tag.slice(0, SET_PREFIX.length) === SET_PREFIX ? tag.slice(SET_PREFIX.length) : tag;
      return '<button type="button" class="mc-sidebar__chip" data-chip="1">' +
        escapeHtml(label) +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>';
    }).join('');

    Array.from(container.children).forEach(function (chip, i) {
      chip.addEventListener('click', function () {
        if (window.MC && window.MC.multiSelect) window.MC.multiSelect.toggle(selected[i], 'set');
      });
    });
  }

  function initSetSearch() {
    var input = document.getElementById('mc-tcg-set-search');
    if (input) {
      wireAutocomplete({
        inputId: 'mc-tcg-set-search',
        boxId: 'mc-tcg-set-suggestions',
        emptyLabel: 'No sets found',
        getPool: function () {
          var state = window.MC && window.MC.multiSelect ? window.MC.multiSelect.getState() : null;
          var selected = (state && state.multi && state.multi.set) || [];
          var selectedHandles = selected.map(handleize);
          return getSetValues().filter(function (s) { return selectedHandles.indexOf(handleize(SET_PREFIX + s)) === -1; });
        },
        onChoose: function (name, inputEl) {
          inputEl.value = '';
          if (window.MC && window.MC.multiSelect) window.MC.multiSelect.toggle(SET_PREFIX + name, 'set');
        }
      });
    }
    renderChips();
  }

  function init() {
    initSetSearch();
    installGlobalDismissListener();
  }

  window.MC = window.MC || {};
  window.MC.initTcgSealedFilters = init;
  window.MC.renderTcgSealedChips = renderChips;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
